export default __webpack_public_path__ + "static/media/ocean.8d9e69ca.png";